import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { TableHeader } from 'components/table/table-content';
import { Filters } from 'elements/Filter';
import { PubSub } from 'lib/event/PubSub';
import { FilterManager } from 'lib/tables/FilterManager';
import { AsyncErrorHandler } from 'lib/ui';
import { PenDesignTypeDto } from 'models/pen/PenDesignType';
import { PenDesignTypeService } from 'services/pen/pen-design-type-service';

@autoinject
export class PenDesignTypeList {
  protected tableData: Array<PenDesignTypeDto>;
  protected activeTableRow: number;

  protected tableHeaders: TableHeader<PenDesignTypeDto>[] = [{ key: 'Name', label: 'general.name', sortable: true }];

  constructor(
    private eventAggregator: EventAggregator,
    protected fm: FilterManager,
    protected penDesignTypeService: PenDesignTypeService,
    private pubsub: PubSub
  ) {
    pubsub.sub('filter-manager:filter-changed', () => {
      this.updateView();
    });
  }

  protected async attached() {
    this.eventAggregator.subscribe('penDesignTypeReset', () => {
      this.activeTableRow = null;
      return this.updateView();
    });

    this.fm.init({
      context: 'pen-design-type-list',
      storageKey: 'pen-design-type-list',
      filters: {
        //TODO
      } satisfies Filters,
      defaultFilters: {
        //TOD
      },
    });

    this.updateView();
  }

  @AsyncErrorHandler
  async updateView() {
    const response = await this.penDesignTypeService.getPenDesignTypes(this.fm.queryFilter);

    if (!response) return;
    this.fm.paginationTotalRecords = +response.headers.get('x-total-count') || 0;

    this.tableData = response.data;
  }

  protected setOrderByColumn(column: string) {
    this.fm.setOrderByColumn(column);
  }

  protected detached() {
    this.pubsub.unsub();
  }

  protected unbind() {
    this.pubsub.unsub();
  }
}
